// import React from "react";
// import { CONSTANTS } from "config/constant";
// import minusIcon from "../../assets/img/orders/minusIcon.png";
// import plusIcon from "../../assets/img/orders/plusIcon.png";

// const DetailModalCardEdit = ({
//   selectedItem,
//   handleCountMinus,
//   handleCountPlus,
//   itemCounts,
//   itemNotes,
//   updateNote,
// }) => {
//   if (!selectedItem) {
//     return null;
//   }

//   const handleNoteChange = (e) => {
//     if (selectedItem && selectedItem._id) {
//       updateNote(selectedItem._id, e.target.value);
//     }
//   };
//   console.log("selectedItem", selectedItem);
//   return (
//     <>
//       <div className="flex items-center justify-around pb-0 pt-0">
//         <div>
//           <img
//             src={CONSTANTS?.BACKEND_URL + selectedItem?.images?.[0]?.file_url}
//             alt="Thobe Summer"
//             className="h-32 w-32 rounded-[50%] object-cover"
//           />
//           <p className="mt-3 text-center text-sm text-gray-500">
//             {selectedItem?.name}
//           </p>
//         </div>
//         <div>
//           {selectedItem?.item_info
//             ? selectedItem?.item_info?.item_service?.map((service) => {
//                 const itemId = service?._id;
//                 const initialCount = service.quantity || 0;
//                 const count = itemCounts[itemId]
//                   ? itemCounts[itemId]
//                   : initialCount;
//                 console.log("count===> edit", service);
//                 console.log("count===> count", count, initialCount);

//                 return (
//                   <div
//                     key={itemId}
//                     className="flex items-center justify-center gap-2"
//                   >
//                     <div className="mb-4">
//                       <p className="text-sm text-gray-500">
//                         {service?.service_name}
//                       </p>
//                       <div>
//                         <h3 className="font-poppins font-semibold text-[#3860A4]">
//                           SAR {service?.price * count}
//                         </h3>
//                       </div>
//                     </div>
//                     <div
//                       className=" ml-auto flex space-x-4 bg-[#172e5512]"
//                       style={{
//                         padding: "4px 6px",
//                         borderRadius: "100px",
//                         width: "5.5rem",
//                       }}
//                     >
//                       <img
//                         src={minusIcon}
//                         className="w-[1.2rem] cursor-pointer"
//                         // onClick={() => handleCountMinus(itemId)}
//                         onClick={() => handleCountMinus({ count, itemId })}

//                       />
//                       <p className="text-600 text-[#3860A4]">{count}</p>
//                       <img
//                         src={plusIcon}
//                         className="w-[1.2rem] cursor-pointer"
//                         onClick={() => handleCountPlus({ count, itemId })}
//                       />
//                     </div>
//                   </div>
//                 );
//               })
//             : selectedItem?.item_service?.map((service) => {
//                 const itemId = service?._id;
//                 const initialCount = service.quantity || 0;
//                 const count = itemCounts[itemId]
//                   ? itemCounts[itemId]
//                   : initialCount;
//                 console.log("count===>", initialCount, count);
//                 console.log("service ===>",service)
//                 return (
//                   <div
//                     key={itemId}
//                     className="flex items-center justify-center gap-2"
//                   >
//                     <div className="mb-4">
//                       <p className="text-sm text-gray-500">
//                         {service?.service_info?.name}
//                       </p>
//                       <div>
//                         <h3 className="font-poppins font-semibold text-[#3860A4]">
//                           SAR {service?.price * count}
//                         </h3>
//                       </div>
//                     </div>
//                     <div
//                       className=" ml-auto flex space-x-4 bg-[#172e5512]"
//                       style={{
//                         padding: "4px 6px",
//                         borderRadius: "100px",
//                         width: "5.5rem",
//                       }}
//                     >
//                       <img
//                         src={minusIcon}
//                         className="w-[1.2rem] cursor-pointer"
//                         // onClick={() => handleCountMinus(itemId)}
//                         onClick={() => handleCountMinus({ count, itemId })}

//                       />
//                       <p className="text-600 text-[#3860A4]">{count}</p>
//                       <img
//                         src={plusIcon}
//                         className="w-[1.2rem] cursor-pointer"
//                         onClick={() => handleCountPlus({ count, itemId })}
//                       />
//                     </div>
//                   </div>
//                 );
//               })}
//         </div>
//       </div>

//       <div className="relative mt-4">
//         <label
//           htmlFor="note"
//           className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
//         >
//           Add Note
//         </label>
//         <input
//           id="note"
//           className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
//           type="text"
//           name="note"
//           placeholder="Add Note"
//           value={itemNotes[selectedItem?._id] || ""}
//           onChange={handleNoteChange}
//         />
//       </div>
//     </>
//   );
// };

// export default DetailModalCardEdit;

import React, { useEffect } from "react";
import { CONSTANTS } from "config/constant";
import minusIcon from "../../assets/img/orders/minusIcon.png";
import plusIcon from "../../assets/img/orders/plusIcon.png";

const DetailModalCardEdit = ({
  selectedItem,
  handleCountMinus,
  handleCountPlus,
  itemCounts,
  itemNotes,
  updateNote,
}) => {
  // if (!selectedItem) {
  //   return null;
  // }
  
  const handleNoteChange = (e) => {
    console.log(e.target.value,'iamnote')
    if (selectedItem && selectedItem?._id) {
      updateNote(selectedItem?._id, e.target.value);
    }
  };
  
  useEffect(()=> {
    console.log(selectedItem?._id, selectedItem?.item_info?.handle_note,'notesssssssssss')
    updateNote(selectedItem?._id, selectedItem?.item_info?.handle_note)
  },[selectedItem])
  console.log(selectedItem,'selectedItemssss')
  return (
    <>
      <div className="flex items-center justify-around pb-0 pt-0">
        <div>
          <img
            src={CONSTANTS?.IMG_DIRECTORY + selectedItem?.images?.[0]?.file_url}
            alt="Thobe Summer"
            className="h-32 w-32 rounded-[50%] object-cover"
          />
          <p className="mt-3 text-center text-sm text-gray-500">
            {selectedItem?.name}
          </p>
        </div>
        <div>
          {selectedItem?.item_info
            ? selectedItem?.item_info?.item_service?.map((service) => {
                const itemId = selectedItem._id;
                const serviceId = service._id;
                const key = `${itemId}_${serviceId}`;
                const initialCount = service.quantity || 0;
                const count =
                  itemCounts[key] !== undefined
                    ? itemCounts[key]
                    : initialCount;
                return (
                  <div
                    key={serviceId}
                    className="flex items-center justify-center gap-2"
                  >
                    <div className="mb-4">
                      <p className="text-sm text-gray-500">
                        {service?.service_name}
                      </p>
                      <div>
                        <h3 className="font-poppins font-semibold text-[#3860A4]">
                          {/* SAR {count ? service?.price * count : service?.price} */}
                          SAR {service?.price}

                        </h3>
                      </div>
                    </div>
                    <div
                      className="ml-auto flex space-x-4 bg-[#172e5512]"
                      style={{
                        padding: "4px 6px",
                        borderRadius: "100px",
                        width: "5.5rem",
                      }}
                    >
                      <img
                        src={minusIcon}
                        className="w-[1.2rem] cursor-pointer"
                        onClick={() =>
                          handleCountMinus({ itemId, serviceId, count })
                        }
                        alt=""
                      />
                      <p className="text-600 text-[#3860A4]">{count}</p>
                      <img
                        src={plusIcon}
                        className="w-[1.2rem] cursor-pointer"
                        // onClick={() => handleCountPlus({ itemId, serviceId })}
                        onClick={() =>
                          handleCountPlus({ itemId, serviceId, count })
                        }
                        alt=""
                      />
                    </div>
                  </div>
                );
              })
            : selectedItem?.item_service?.map((service) => {
                const itemId = selectedItem._id;
                const serviceId = service._id;
                const key = `${itemId}_${serviceId}`;
                const initialCount = service.quantity || 0;
                const count = itemCounts[key] ? itemCounts[key] : initialCount;
                return (
                  <div
                    key={serviceId}
                    className="flex items-center justify-center gap-2"
                  >
                    <div className="mb-4">
                      <p className="text-sm text-gray-500">
                        {service?.service_info?.name}
                      </p>
                      <div>
                        <h3 className="font-poppins font-semibold text-[#3860A4]">
                          {/* SAR {service?.price * count} */}
                          {/* SAR {count ? service?.price * count : service?.price} */}
                          SAR {service?.price}

                        </h3>
                      </div>
                    </div>
                    <div
                      className="ml-auto flex space-x-4 bg-[#172e5512]"
                      style={{
                        padding: "4px 6px",
                        borderRadius: "100px",
                        width: "5.5rem",
                      }}
                    >
                      <img
                        src={minusIcon}
                        className="w-[1.2rem] cursor-pointer"
                        onClick={() =>
                          handleCountMinus({ itemId, serviceId, count })
                        }
                        alt=""
                      />
                      <p className="text-600 text-[#3860A4]">{count}</p>
                      <img
                        src={plusIcon}
                        className="w-[1.2rem] cursor-pointer"
                        onClick={() =>
                          handleCountPlus({ itemId, serviceId, count })
                        }
                        alt=""
                      />
                    </div>
                  </div>
                );
              })}
        </div>
      </div>

      <div className="relative mt-4">
        <label
          htmlFor="note"
          className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
        >
          Add Note
        </label>
        <input
          id="note"
          className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
          type="text"
          name="note"
          placeholder="Add Note"
          value={itemNotes[selectedItem?._id] || ""}
          onChange={handleNoteChange}
        />
      </div>
    </>
  );
};

export default DetailModalCardEdit;
